import React from 'react';
import { getToken } from '../../lib/api';

const AiVexRedirectPage: React.FC = () => {
  const hostname = window.location.hostname;
  let vexUrl: string;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    vexUrl = 'http://localhost:4180';
  } else {
    vexUrl = `https://vex.${hostname}`;
  }

  // 与主站共用登录：把主站 token 通过 URL hash 通道带给 VEX（hash 不进服务器日志/Referer）
  const token = getToken();
  window.location.href = token
    ? `${vexUrl}#token=${encodeURIComponent(token)}`
    : vexUrl;

  return (
    <div className="h-screen w-screen bg-[#0c0c0e] flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-700 border-t-purple-500"></div>
        <span className="text-gray-500 font-mono text-sm">REDIRECTING TO AI VEX...</span>
      </div>
    </div>
  );
};

export default AiVexRedirectPage;
